import { useState, useEffect, useCallback } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { Row, Jumbotron, ToggleButtonGroup, ToggleButton } from 'react-bootstrap'
import BancontactForm from './../components/BancontactForm'
import CardForm from './../components/CardForm'
import PaymentError from './../components/PaymentError'
import DownloadMessage from './DownloadMessage'
import bancontact from './../img/bancontact.svg'
import creditCard from './../img/credit_card.svg'

const StripePayment = ({ stripePromise, processingBancontactPayment }) => {
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState({
    completed: false,
    certificate: null
  })
  const [mode, setMode] = useState('card')
  const [loading, setLoading] = useState(false)

  // Memoize handlers to prevent unnecessary re-renders of child components
  const handleLoading = useCallback((newLoadingState) => {
    setLoading(newLoadingState)
  }, [])

  const handleError = useCallback((newErrorState) => {
    setError(newErrorState)
  }, [])

  const handleSuccess = useCallback((sucess) => {
    setSuccess(sucess)
  }, [])

  const handleModeChange = (val) => {
    if (mode !== val) {
      setMode(val)
    }
  }

  let input = <CardForm handleLoading={handleLoading} handleError={handleError} handleSuccess={handleSuccess} loading={loading} />
  if (mode === 'bancontact') {
    input = <BancontactForm processingBancontactPayment={processingBancontactPayment} handleLoading={handleLoading} handleError={handleError} handleSuccess={handleSuccess} loading={loading} />
  }

  useEffect(() => {
    if (processingBancontactPayment.status) {
      setMode('bancontact')
    }
  }, [processingBancontactPayment.status])

  return (
    <>
      <ToggleButtonGroup className='mb-4' type='radio' name='paymentMethod' size='lg' value={mode} onChange={handleModeChange}>
        <ToggleButton variant='light' value='card' disabled={success.completed || loading || error}>
          <img src={creditCard} height='16' className='mr-3' alt='Credit card' />
          Kredietkaart
        </ToggleButton>
        <ToggleButton variant='light' value='bancontact' disabled={success.completed || loading || error}>
          <img src={bancontact} height='16' className='mr-3' alt='Bancontact' />
          Bancontact
        </ToggleButton>
      </ToggleButtonGroup>
      {success.completed ? (
        <Row>
          <DownloadMessage title='U bent verzekerd voor dit mandaat' certificate={success.certificate} />
        </Row>
      ) : (
        <>
          <Jumbotron>
            {error && (
              <PaymentError error={error} />
            )}
            {!error && (
              <Elements stripe={stripePromise} options={{ locale: 'nl' }}>
                {input}
              </Elements>
            )}
          </Jumbotron>
        </>
      )}
    </>
  )
}

export default StripePayment
